const { detect } = require('detect-browser');

var ie_mixin = {
  data: function() {
    return {
      occupationsSelectedIE: [],
      servicesSelectedIE: []
    }
  },
  computed: {
    isIE() {
      if (detect()) {
        return detect().name == "ie"
      }
    },
    occupationsOptionsIE() {
      if (this.occupationsOptions) {
        return this.occupationsOptions.map(item => item['name'])
      }
    },
    servicesOptionsIE() {
      if (this.servicesOptions) {
        return this.servicesOptions.map(item => item['name'])
      }
    },
    allServicesOptionsIE() {
      if (this.allServicesOptions) {
        return this.allServicesOptions.map(item => item['name'])
      }
    },
  },
  methods: {
    searchValuesInArray(keys, array, attribute = "name") {
      let values = []

      for (var i=0; i < array.length; i++) {
        if (keys.includes(array[i][attribute])) {
          values.push(array[i]);
        }
      }

      return values;
    },
    searchInArray(key, array, attribute = "name"){
      for (var i=0; i < array.length; i++) {
        if (array[i][attribute] === key) {
          return array[i];
        }
      }
    },
    getIdsFromValues(item_names, options, attribute = "name") {
      let values = []

      values = this.searchValuesInArray(item_names, options, attribute)
      return values.map(item => item['id'])
    }
  }
}

if(typeof Element.prototype.remove !== "function") {
  Element.prototype.remove = function() {
    this.parentElement.removeChild(this);
  }
}

if(typeof NodeList.prototype.remove !== "function") {
  NodeList.prototype.remove = function() {
    for(var i = this.length - 1; i >= 0; i--) {
      if(this[i] && this[i].parentElement) {
        this[i].parentElement.removeChild(this[i]);
      }
    }
  }
}

if(typeof HTMLCollection.prototype.remove !== "function") {
  HTMLCollection.prototype.remove = NodeList.prototype.remove;
}

export default ie_mixin;



// WEBPACK FOOTER //
// ./src/mixin/ie.js